import React, {useState, useEffect} from "react";
import MiniLineBackChartWrapper from "./minilineback.style";
import { Line } from "react-chartjs-2";
import _ from "lodash";
import classNames from "classnames";
import customTooltip from "components/common/chartTooltip";
import {
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import classnames from "classnames";




const MiniLineBackgroundWidget = props => {


  const [navItems, setNavItems] = useState([]);
  const [dataSet, setDataSet] = useState([]);
  const [activeTab, setActiveTab] = useState("magpsia")
  const [labels, setLabels] = useState([])
  var interval;


  const {
    barBackground,
    dark = false,
    background = "#ffffff",
    barColor,
    className,
  } = props;


  const toggle = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      clearInterval(interval);
    }
  };

  useEffect(() => {
    interval = setTimeout(() => {
      if(activeTab !== "magpsia") {
        setActiveTab("magpsia")
      } else {
        setActiveTab("averagepower")
      }
    }, 5000)
    return () => {clearInterval(interval)};
  })

  useEffect(() => {
    if(props.chartData) {
      setNavItems(_.keys(props.chartData))
      props.chartData.averagepower.data = props.chartData.averagepower.data.map(o => parseFloat(o));
      setDataSet(props.chartData)
      setLabels(props.chartData.time)
    }
  }, [props.chartData])

  const data = {
    labels: labels,
    datasets: [
      {
        label: "Data",
        backgroundColor: barBackground,
        borderColor: barColor,
        borderWidth: 3,
        hoverBackgroundColor: "rgba(255,99,132,0.4)",
        hoverBorderColor: barColor,
        data: dataSet[activeTab] ? dataSet[activeTab].data : []
      }
    ]
  };

  const options = {
    tooltips: {
      enabled: false,
      custom: customTooltip
    },
    maintainAspectRatio: false,
    scaleShowLabels: false,
    legend: false,
    scales: {
      xAxes: [
        {
          display: false,
          barPercentage: 0.3
        }
      ],
      yAxes: [
        {
          display: true,
          ticks: {
            max: activeTab === "magpsia" ? 20 : 1,
            min: activeTab === "magpsia" ? 10 : 0,
           }
        }
      ]
    }
  };

  return (
    <MiniLineBackChartWrapper dark={dark} background={background}>
    <div className={classNames("roe-card-style roe-shadow-2", className)}>
    {   
      (navItems[0] && navItems[1]) &&
      <Nav tabs>

        <NavItem key={0}>
          <NavLink
            className={classnames(
                { active: activeTab === navItems[0] },
                "doc-title"
            )}
            onClick={() => {
                toggle(navItems[0]);
            }}
          >
            {dataSet[navItems[0]].title}
          </NavLink>
        </NavItem>      
        <NavItem key={1}>
          <NavLink
            className={classnames(
                { active: activeTab === navItems[1] },
                "doc-title"
            )}
            onClick={() => {
                toggle(navItems[1]);
            }}
          >
          {dataSet[navItems[1]].title}
          </NavLink>
        </NavItem>      
    
    
      </Nav>
    }

          <div className="roe-card-body pt-24 backImage">
            <div className="flex-x align-center">
              <div className="fs-26 demi-bold-text widget-dark-color">
                {dataSet[activeTab] ? (dataSet[activeTab] ? _.takeRight(dataSet[activeTab].data) : 0) : 0}
              </div>
              <div className="fs-16 bold-text widget-light-grey-color pt-20 pl-10">
                {dataSet[activeTab] ? dataSet[activeTab]["title"] : ""}
              </div>
            </div>
            <div className="ptb-10">
              <Line data={data} height={250} options={options} />
            </div>
          </div>
        </div>
      </MiniLineBackChartWrapper>

  );
};

export default MiniLineBackgroundWidget;
